import { Routes, Route, Navigate } from 'react-router-dom'
import Home from './pages/Home'
import Programmes from './pages/Programmes'
import Projets from './pages/Projets'
import Contact from './pages/Contact'
import Presentation from './pages/Presentation'
import Experts from './pages/Experts'
import Organigramme from './pages/Organigramme'
import Login from './admin/Login'
import Dashboard from './admin/Dashboard'
import DetailProjet from './pages/DetailProjet'
import DetailSeminaire from './pages/DetailSeminaire'
import DetailProgramme from './pages/DetailProgramme'
import NotreHistoire from './pages/NotreHistoire'
import LocauxMateriels from './pages/LocauxMateriels'
import MotDuDG from './pages/MotDuDG'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import useAuthStore from './store/authStore'
import { useEffect } from 'react'
import { Loader2 } from 'lucide-react'

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading, checkAuth } = useAuthStore()
  
  useEffect(() => {
    checkAuth()
  }, [])

  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
        <Loader2 className="animate-spin text-cidh-blue mb-4" size={48} />
        <p className="text-gray-500 font-medium">Vérification de la session...</p>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" />
  }
  return children
}

function App() {
  return (
    <div className="flex flex-col min-h-screen">
      <Routes>
        {/* Admin Routes - No Navbar/Footer */}
        <Route path="/admin/login" element={<Login />} />
        <Route 
          path="/admin/*" 
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } 
        />

        {/* Public Routes */}
        <Route path="*" element={
          <>
            <Navbar />
            <main className="flex-grow">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/a-propos/presentation" element={<Presentation />} />
                <Route path="/a-propos/notre-histoire" element={<NotreHistoire />} />
                <Route path="/a-propos/mot-du-dg" element={<MotDuDG />} />
                <Route path="/a-propos/experts" element={<Experts />} />
                <Route path="/a-propos/organigramme" element={<Organigramme />} />
                <Route path="/a-propos/locaux-et-materiels" element={<LocauxMateriels />} />
                <Route path="/programmes" element={<Programmes />} />
                <Route path="/programmes/:id" element={<DetailProgramme />} />
                <Route path="/projets" element={<Projets />} />
                <Route path="/projets/:id" element={<DetailProjet />} />
                <Route path="/seminaires/:id" element={<DetailSeminaire />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
            </main>
            <Footer />
          </>
        } />
      </Routes>
    </div>
  )
}

export default App
